import type {Result, UseCase} from 'framework';
import type {CatalogExercise} from '../../domain/catalog-exercise';
import type {WorkoutError} from '../../domain/errors';
import type {
  ExerciseCatalogRepository,
  UpdateCustomExerciseInput,
} from '../ports/exercise-catalog.repository';

export class UpdateCustomExercise implements UseCase<[UpdateCustomExerciseInput], CatalogExercise> {
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(input: UpdateCustomExerciseInput): Promise<Result<CatalogExercise, WorkoutError>> {
    return this.repository.updateCustom(input);
  }
}
